export default {"src":"/_next/static/media/IconElectrical.3554b2f1.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};